import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  styled,
} from '@material-ui/core';
import { IBook } from '../../../../config/api/models/Book';
import { TreeView } from '@material-ui/lab';
import { TrajectoryTreeViewBook } from './index';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

type Props = {
  title: string;
  description?: string;
  open?: boolean;
  onClose: (result: boolean) => void;
  data: IBook[];
  onSelected: (ChapterId: string, fromBook: string, toBook: string) => void;
};

const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    maxWidth: '50rem',
  },
});

const TreeViewDialog: FC<Props> = ({ title, description, open, onClose, data, onSelected }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string>('');

  const handleConfirmClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClose(true);
  };

  const handleCancelClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClose(false);
  };

  const handleSelect = (chapterId: string, fromBook: string, toBook: string) => {
    onSelected(chapterId, fromBook, toBook);
    setSelected(chapterId);
  };

  return (
    <StyledDialog
      open={open || false}
      onClose={() => onClose(false)}
      aria-labelledby={`confirmation-dialog-${title
        .toLowerCase()
        .replace(/[^\w\s]/g, '')
        .replace(/\s/g, '-')}`}
    >
      <DialogTitle id="simple-dialog-title">{title}</DialogTitle>
      {description && (
        <DialogContent>
          <Typography gutterBottom>{description}</Typography>
        </DialogContent>
      )}
      <DialogContent>
        <TreeView
          defaultExpandIcon={
            <FontAwesomeSpriteIcon icon={SpriteIconsLight.ANGLE_RIGHT} iconSize="lg" />
          }
          defaultCollapseIcon={
            <FontAwesomeSpriteIcon icon={SpriteIconsLight.ANGLE_DOWN} iconSize="lg" />
          }
        >
          {data.map((book, index) => (
            <TrajectoryTreeViewBook
              key={index}
              book={book}
              onSelected={handleSelect}
              selectedChapter={selected}
            />
          ))}
        </TreeView>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={handleCancelClick} disableElevation color="secondary">
          {t('shared.forms.cancel')}
        </Button>
        <Button variant="contained" onClick={handleConfirmClick} disableElevation color="primary">
          {t('shared.forms.confirm')}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default TreeViewDialog;
